var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumb-bg"},[_c('v-container',{staticClass:"py-0",attrs:{"fluid":""}},[_c('v-breadcrumbs',{staticClass:"hidden-sm-and-down",attrs:{"items":_vm.items}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }